<template>
    <div class="card-ticket">
        <div class="row">
            <div class="xs12 pa-3 pb-2">
                <div :class="rowText">
                    <div class="mr-2">
                        <i class="mdi mdi-road"></i>
                    </div>
                    <div :class="textRight">
                        {{
                            item.TenTuyen
                                ? `${item.TenTuyen}${
                                      item.MaTuyen ? ` (${item.MaTuyen})` : ``
                                  }`
                                : ""
                        }}
                    </div>
                </div>
                <div :class="rowText">
                    <div class="mr-2">
                        <i class="mdi mdi-bus-stop"></i>
                    </div>
                    <div :class="textRight">
                        {{ item.BenDi ? item.BenDi : "" }}
                    </div>
                </div>
                <div :class="rowText">
                    <div class="mr-2">
                        <i class="mdi mdi-map-marker-down"></i>
                    </div>
                    <div :class="textRight">
                        {{ item.BenDen ? item.BenDen : "" }}
                    </div>
                </div>
                <div :class="rowText">
                    <div class="mr-2">
                        <i class="mdi mdi-map-marker-distance"></i>
                    </div>
                    <div :class="textRight">
                        {{ item.CuLy ? `${item.CuLy} km` : "" }}
                    </div>
                </div>
                <div :class="rowText">
                    <div class="mr-2">
                        <i class="mdi mdi-format-list-bulleted-type"></i>
                    </div>
                    <div :class="textRight">
                        {{ item.LoaiTuyen ? item.LoaiTuyen : "" }}
                    </div>
                </div>
                <div :class="rowLastText">
                    <div class="mr-2">
                        <i class="mdi mdi-list-status"></i>
                    </div>
                    <div :class="textRight">
                        <div :style="`color: ${item.MaMauTrangThai}`">
                            {{ item.TrangThai }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="xs12">
                <div class="row" style="border-top: 1px solid #dadce0; padding: 0 2px">
                    <div
                        class="xs6 text-xs-center"
                        style="border-right: 1px solid #dadce0"
                    >
                        <DxButton
                            :disabled="
                                !$Helper.KiemTraQuyen(
                                    $t('QuyenLenhDienTu.LENHDIENTU'),
                                    $t('QuyenLenhDienTu.XoaLuongTuyen'),
                                )
                            "
                            text="Xóa"
                            type="danger"
                            styling-mode="text"
                            width="100%"
                            @click="XoaTuyen"
                        />
                    </div>
                    <div class="xs6 text-xs-center">
                        <DxButton
                            text="Sửa"
                            type="default"
                            styling-mode="text"
                            width="100%"
                            @click="
                                $router.push({
                                    path: '/Thong-Tin-Tuyen',
                                    query: { IdLuongTuyen: item.IdLuongTuyen },
                                })
                            "
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Xác nhận cập nhật thông tin -->
    <PopupVue
        height="auto"
        v-if="ifPopupXacNhanXoa"
        v-model:dialog="PopupXacNhanXoa"
        title=""
        buttonTextLeft="Hủy"
        buttonTextRight="Đồng ý"
        class="popup-padding-8"
        @close="XacNhanXoa"
        heightScrollView="auto"
    >
        <template #content>
            <ThongBaoVue
                :message="ParamThongBao.message"
                :state="ParamThongBao.state"
                :title="ParamThongBao.title"
            />
        </template>
    </PopupVue>
</template>

<script>
import { DxButton } from "devextreme-vue";
import ThongBaoVue from "../../../../components/_Common/ThongBao.vue";
import PopupVue from "../../../../components/_Common/Popup.vue";
export default {
    components: {
        DxButton,
        ThongBaoVue,
        PopupVue,
    },
    props: {
        item: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            rowText: "row mb-1 align-center row-text",
            rowLastText: "row align-center row-text",
            textRight: " font-medium",
            ifPopupXacNhanXoa: false,
            PopupXacNhanXoa: false,
            IdLuongTuyen: null,
            ParamThongBao: {
                state: "Warning",
                title: "Bạn có chắc chắn xóa luồng tuyến đã chọn?",
                message: "",
            },
        };
    },
    computed: {},
    watch: {
        PopupXacNhanXoa() {
            if (!this.PopupXacNhanXoa) {
                this.NgatDOMPopup("ifPopupXacNhanXoa");
            }
        },
    },
    methods: {
        showPopup(name) {
            this["if" + name] = true;
            this[name] = true;
        },
        NgatDOMPopup(key) {
            setTimeout(() => {
                this[key] = false;
            }, 300);
        },
        XoaTuyen() {
            this.IdLuongTuyen = this.item.IdLuongTuyen + "";
            this.showPopup("PopupXacNhanXoa");
        },
        XacNhanXoa(bool) {
            if (bool == false) {
                this.PopupXacNhanXoa = false;
            } else if (bool == true) {
                this.PopupXacNhanXoa = false;
                this.ThucHienXoaTuyen();
            }
        },
        async ThucHienXoaTuyen() {
            try {
                let rs = await this.$store.dispatch(
                    "ThongTinLuongTuyen/XoaLuongTuyen",
                    this.IdLuongTuyen,
                );
                this.PopupXacNhanXoa = false;
                if (rs.status == true) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        `Xóa thông tin luồng tuyến thành công!`,
                    );
                    this.$emit("getData");
                } else if (rs.status == false) {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Xóa thông tin luồng tuyến thất bại!",
                        message: rs.message,
                    });
                }
            } catch (ex) {
                this.PopupXacNhanXoa = false;
                this.$Helper.ThongBaoPopup({
                    message_title: "Xóa thông tin luồng tuyến thất bại!",
                    message: "Lỗi hệ thống client.",
                });
            }
        },
    },
};
</script>

<style scoped>
.card-ticket {
    position: relative;
    box-shadow: 0px 2px 9px #ccc;
    overflow: hidden;
}
.row-text {
    word-break: break-word;
    white-space: break-spaces;
}
:deep(.custom-action-sheet .dx-toolbar-label div) {
    font-size: 20px;
    font-weight: 500;
}
</style>
